import React from "react";
import {
    Page,
    Text,
    View,
    Document,
    StyleSheet,
    Image,
} from "@react-pdf/renderer";

/* =========================
   STYLES
========================= */

const styles = StyleSheet.create({
    page: {
        // paddingTop: 100,
        // paddingBottom: 60,
        // paddingHorizontal: 30,
        // fontSize: 9,
         padding: 20,
        fontSize: 9,
    },

    headerWrapper: {
        position: "absolute",
        top: 20,
        left: 20,
        right: 20,
        height: 60,
        justifyContent: "center",
        alignItems: "center",
    },
    headerImage: {
        width: "100%",
        height: 60,
        objectFit: "contain",
    },
    footerWrapper: {
        position: "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        height: 50,
    },
    footerImage: {
        width: "100%",
        height: "100%",
    },

    reportTitle: {
        textAlign: "center",
        fontSize: 12,
        marginBottom: 15,
        fontWeight: "bold",
    },

    projectBox: {
        marginBottom: 15,
    },

    projectHeader: {
        backgroundColor: "#eaeaea",
        padding: 5,
        borderWidth: 1,
        borderColor: "#000",
    },

    overheadBox: {
        marginTop: 8,
        borderWidth: 1,
        borderColor: "#000",
        padding: 5,
    },

    overheadTitle: {
        marginBottom: 4,
        marginTop: 6,
        fontWeight: "bold",
    },

    table: {
        width: "100%",
        marginTop: 4,
    },

    tableRow: {
        flexDirection: "row",
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: "#000",
    },

    /* FIXED WIDTHS - IMPORTANT */
    colSl: {
        width: 40,
        padding: 3,
        textAlign: "center",
        borderRightWidth: 1,
        borderColor: "#000",
    },

    colDate: {
        width: 80,
        padding: 3,
        textAlign: "center",
        borderRightWidth: 1,
        borderColor: "#000",
    },

    colComment: {
        flex: 1,
        padding: 3,
        textAlign: "center",
        borderRightWidth: 1,
        borderColor: "#000",
    },

    colAmount: {
        width: 70,
        padding: 3,
        textAlign: "center",
    },
    colsSl: {
        width: 40,
        padding: 3,
        borderRightWidth: 1,
        borderColor: "#000",
    },

    colsDate: {
        width: 80,
        padding: 3,
        borderRightWidth: 1,
        borderColor: "#000",
    },

    colsComment: {
        flex: 1,
        padding: 3,
        borderRightWidth: 1,
        borderColor: "#000",
    },

    colsAmount: {
        width: 70,
        padding: 3,
        textAlign: "right",
    },
    tableHeaderText: {
        fontWeight: "bold",
    },

    totalRow: {
        flexDirection: "row",
        borderLeftWidth: 1,
        borderRightWidth: 1,
        borderBottomWidth: 1,
        borderColor: "#000",
    },

    totalLabel: {
        flexGrow: 1,
        padding: 4,
        textAlign: "right",
        fontWeight: "bold",
        borderRightWidth: 1,
        borderColor: "#000",
    },

    totalAmount: {
        width: 70,
        padding: 4,
        fontWeight: "bold",
        textAlign: "right",
    },
    projectTotalBox: {
        marginTop: 5,
        borderWidth: 1,
        borderColor: "#000",
        padding: 5,
        backgroundColor: "#f2f2f2",
    },
    projectSummary: {
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%",
        marginTop: 5,
        fontSize: 10,
        fontWeight: "bold",
    },
    separator: {
        width: "100%",
        height: 1,
        backgroundColor: "#000",
        marginTop: 12,
        marginBottom: 12,
    },
});

/* =========================
   GROUP HELPERS
========================= */

const groupByProject = (rows) => {
    const result = {};
    rows.forEach((r) => {
        if (!result[r.ProjectName]) result[r.ProjectName] = [];
        result[r.ProjectName].push(r);
    });
    return result;
};

const groupByOverhead = (rows) => {
    const result = {};
    rows.forEach((r) => {
        if (!result[r.Overhead]) result[r.Overhead] = [];
        result[r.Overhead].push(r);
    });
    return result;
};

/* =========================
   MAIN PDF
========================= */

const ExpenseOHPDF = ({ data = [], filters = {} }) => {
    // const projects = groupByProject(data);
    const filteredData = data.filter(
        (r) => Number(r.Amount || 0) !== 0
    );

    const overheadGroups = groupByOverhead(filteredData);

    const formatAmount = (val) =>
        Number(val || 0).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });

    const headerPath = filters?.HeaderImg
        ? `${filters.Imageurl}/uploads/images/${filters.HeaderImg}`
        : null;

    const footerPath = filters?.FooterImg
        ? `${filters.Imageurl}/uploads/images/${filters.FooterImg}`
        : null;

    return (
        <Document>
            <Page size="A4" style={styles.page}>

                {/* HEADER */}
                {/* <View fixed style={styles.headerWrapper}>
                    {headerPath ? (
                        <Image src={headerPath} style={styles.headerImage} />
                    ) : (
                        <View style={{ width: "100%", height: 60, backgroundColor: "#eee" }} />
                    )}
                </View> */}
                <Text style={styles.reportTitle}>
                    Expense - Overhead Based Summary Report
                </Text>


                {Object.entries(overheadGroups).map(([overheadName, overheadRows], oIndex) => {

                    const projects = groupByProject(overheadRows);

                    const overheadTotal = overheadRows.reduce(
                        (sum, r) => sum + Number(r.Amount || 0),
                        0
                    );

                    return (
                        <View key={oIndex} style={styles.projectBox}>

                            {/* OVERHEAD HEADER */}
                            <View style={styles.projectHeader}>
                                <Text>Overhead : {overheadName}</Text>
                            </View>

                            {Object.entries(projects).map(([projectName, projectRows], pIndex) => {

                                const projectTotal = projectRows.reduce(
                                    (sum, r) => sum + Number(r.Amount || 0),
                                    0
                                );

                                return (
                                    <View key={pIndex} style={{ marginTop: 8 }} wrap={false}>

                                        <Text style={styles.overheadTitle}>
                                            Project : {projectName}
                                        </Text>

                                        <View style={styles.table}>

                                            {/* HEADER */}   <View
                                                style={[
                                                    styles.tableRow,
                                                    { borderTopWidth: 1, borderColor: "#000" }
                                                ]}
                                            >
                                                {/* <View style={styles.tableRow}> */}

                                                <Text style={[styles.colSl, styles.tableHeaderText]}>SL#</Text>
                                                <Text style={[styles.colDate, styles.tableHeaderText]}>Date</Text>
                                                <Text style={[styles.colComment, styles.tableHeaderText]}>Comments</Text>
                                                <Text style={[styles.colAmount, styles.tableHeaderText]}>Amount</Text>
                                            </View>

                                            {projectRows.map((r, i) => (
                                                <View key={i} style={styles.tableRow}>
                                                    <Text style={styles.colsSl}>{i + 1}</Text>
                                                    <Text style={styles.colsDate}>{r.FEDate}</Text>
                                                    <Text style={styles.colsComment}>
                                                        {r.Comments || "-"}
                                                    </Text>
                                                    <Text style={styles.colsAmount}>
                                                        {formatAmount(r.Amount)}
                                                    </Text>
                                                </View>
                                            ))}

                                            {/* PROJECT TOTAL */}
                                            <View style={styles.totalRow}>
                                                <Text style={styles.totalLabel}>
                                                    Total
                                                </Text>
                                                <Text style={styles.totalAmount}>
                                                    {formatAmount(projectTotal)}
                                                </Text>
                                            </View>

                                        </View>
                                    </View>
                                );
                            })}

                            {/* OVERHEAD TOTAL */}
                            <View style={styles.projectSummary}>
                                <Text>Overhead Name : {overheadName}</Text>
                                <Text>Total Transactions : {overheadRows.length}</Text>
                                <Text>Overhead Total : {formatAmount(overheadTotal)}</Text>
                            </View>

                            <View style={styles.separator} />

                        </View>
                    );
                })}
                {/* FOOTER */}
                {/* {footerPath && (
                    <View fixed style={styles.footerWrapper}>
                        <Image src={footerPath} style={styles.footerImage} />
                    </View>
                )} */}

            </Page>
        </Document>
    );
};

export default ExpenseOHPDF;